import { render, staticRenderFns } from "./FriendsSquareView.vue?vue&type=template&id=7460ce10&scoped=true"
import script from "./FriendsSquareView.vue?vue&type=script&lang=js"
export * from "./FriendsSquareView.vue?vue&type=script&lang=js"
import style0 from "./FriendsSquareView.vue?vue&type=style&index=0&id=7460ce10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7460ce10",
  null
  
)

export default component.exports